import * as Sentry from '@sentry/browser';
Sentry.init({
  // for web only - we need to set dsn to null in local environments to prevent using up the monthly event limit,
  // for sentry-expo they handle this for us
  dsn: __DEV__ ? null : 'https://336af03a40e74f9b886b1565a1f685cf@o387324.ingest.sentry.io/5222409',
  debug: false,
});

export default Sentry;
